export class CentralTeamsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The teams the caller's grant reaches (`central_team:view`), by country, function and status. */
    list(filter = {}) {
        const params = new URLSearchParams();
        if (filter.country !== undefined)
            params.set('country', filter.country);
        if (filter.function !== undefined)
            params.set('function', filter.function);
        if (filter.status !== undefined)
            params.set('status', filter.status);
        const qs = params.toString();
        return this.client.request({ method: 'GET', path: `/v1/central/teams${qs !== '' ? `?${qs}` : ''}`, auth: true });
    }
    /** One team with its members, its audit and the names to show (`central_team:view`). */
    get(teamId) {
        return this.client.request({ method: 'GET', path: `/v1/central/teams/${encodeURIComponent(teamId)}`, auth: true });
    }
    /** Create a team (`central_team:manage` at its country, and at every market of a subset). */
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/central/teams', body: input, auth: true });
    }
    /** Edit a team under compare-and-set: `version` is the one the caller read (409 `TEAM_VERSION_CONFLICT` when it moved). */
    update(teamId, version, patch) {
        return this.client.request({ method: 'PATCH', path: `/v1/central/teams/${encodeURIComponent(teamId)}`, body: { ...patch, version }, auth: true });
    }
    /** Archive a team: read-only afterwards, members kept; its scope is free for a new team. */
    archive(teamId, version) {
        return this.client.request({ method: 'POST', path: `/v1/central/teams/${encodeURIComponent(teamId)}/archive`, body: { version }, auth: true });
    }
    /** Restore an archived team (409 `TEAM_SCOPE_DUPLICATE` when another ACTIVE team took its scope). */
    restore(teamId, version) {
        return this.client.request({ method: 'POST', path: `/v1/central/teams/${encodeURIComponent(teamId)}/restore`, body: { version }, auth: true });
    }
    /**
     * Add a person to a team, or change their role when they are already in it (201 added, 200 role changed). Membership never widens a
     * grant: the person needs a desk grant that already reaches the team (400 `MEMBER_NOT_DESK_AGENT` / `MEMBER_GRANT_DOES_NOT_REACH_TEAM`).
     */
    addMember(teamId, memberId, role) {
        return this.client.request({ method: 'POST', path: `/v1/central/teams/${encodeURIComponent(teamId)}/members`, body: { memberId, role }, auth: true });
    }
    /** Take a person out of a team (404 `MEMBER_NOT_IN_TEAM` when they were not in it). */
    removeMember(teamId, memberId) {
        return this.client.request({ method: 'DELETE', path: `/v1/central/teams/${encodeURIComponent(teamId)}/members/${encodeURIComponent(memberId)}`, auth: true });
    }
    /** The teams a person belongs to, inside the caller's countries (`central_team:view`). */
    teamsOfMember(memberId) {
        return this.client.request({ method: 'GET', path: `/v1/central/members/${encodeURIComponent(memberId)}/teams`, auth: true });
    }
    /** Create the missing default teams of a registered country (idempotent; `central_team:manage` at the country). */
    ensureDefaults(countryCode) {
        return this.client.request({ method: 'POST', path: '/v1/central/team-defaults', body: { countryCode }, auth: true });
    }
}
//# sourceMappingURL=central-teams.js.map